import Vue from 'vue'
import './components'
import './plugins'
import vuetify from'./plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'
import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, "$config", {
  get() {
    return config;
  }
});
router.beforeEach((to, from, next) => {
  router.secure = false
  router.options.routes.forEach((route) => {
    if (to.matched[0].path === route.path && route.secure) {
       router.secure = true
    }
  });
  // Proceed as normal
  next();
});


new Vue({
  // we add vuetify here
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
